export enum ReviewsSortBy {
	MostHelpful = 'MOST_HELPFUL',
	LatestReview = 'LATEST_REVIEW',
	EarliestReview = 'EARLIEST_REVIEW',
	HighestRanked = 'HIGHEST_RANKED',
	LowestRanked = 'LOWEST_RANKED',
}

export interface QueryParamsState {
	university: string;
	page: number;
	limit: number;
	offset: number;
	contains: string;
	sortBy: ReviewsSortByUnion;
}

export type ReviewsSortByUnion = `${ReviewsSortBy}`;

export interface ReviewReaction {
	reviewId: number;
	reaction: ReactionType;
}

export enum Reaction {
	LIKE = 1,
	DISLIKE = 2,
}

export type ReactionType = 1 | 2;
